module.exports = __webpack_public_path__ + "img/login-bottom-shape.70bad6a4.png";